/* eslint-disable react/destructuring-assignment */
import React, { useContext } from "react";
import { useSelector } from "react-redux";
import { string, shape, arrayOf, bool } from "prop-types";
import moment from "moment";
import GridTable from "pages/_components/GridTable/GridTable";
import CustomText from "pages/_components/CustomText/CustomText";
import FormattedAmount from "pages/_components/FormattedAmount";
import { TransactionContext } from "pages/_components/TransactionCard/TransactionContext";
import { echeqPropTypes } from "pages/echeck/echeckPropTypes";
import CustomData from "../../../_components/CustomData/CustomData";
import getCellPlacement from "../../../../util/helpers/table";

const CesionSummaryMultipleBody = (props) => {
    const { echeqsToDoActions: echeqAction } = useSelector((state) => state.echecks);
    const { transaction = {} } = useContext(TransactionContext);
    const { data = {}, creationDateTime = moment(), idTransaction = "" } = transaction;
    const { isDesktop } = props;
    const {
        beneficiary = props.beneficiary.document,
        beneficiaryName = props.beneficiary.reference,
        reference = props.reference,
        referencevalue = props.referencevalue,
        caracter = props.caracter || "No a la orden",
        echeqList = props.echeqList,
        cesion = {},
        amount = {},
        coelsaResponse,
        coelsaCode,
    } = data;
    const { currency, quantity } = amount;
    const alignX = "left";
    const alignY = "start";
    const columnTemplate = isDesktop ? "1fr 1fr 1fr" : "1fr";

    const getCellProps = (row, col, cols) => ({
        alignX,
        alignY,
        ...getCellPlacement(row, col, { isDesktop, totalColumns: cols }),
    });

    const getAmoutTotal = () => {
        let total = 0;
        echeqList.forEach((echeq) => {
            total += parseFloat(echeq.monto);
        });
        return total;
    };

    const getCurrency = () => {
        return echeqList[0].moneda;
    }

    return (
        <>
            {idTransaction && (
                <GridTable className="box e-checks-summary p-0">
                    <GridTable.Container columns={3} rows={1}>
                        <GridTable.Data {...getCellProps(1, 1)}>
                            <CustomData
                                titleText="forms.transaction.ticket.dateAndHour"
                                titleTextType="I18N"
                                valueText={
                                    <CustomText
                                        textType="DATE"
                                        text={creationDateTime}
                                        dateFormat="DD/MM/YYYY HH:mm:ss"
                                    />
                                }
                                valueTextType="TEXT"
                            />
                        </GridTable.Data>
                        <GridTable.Data {...getCellProps(1, 2)}>
                            <CustomData
                                titleText="ticket.voucher"
                                titleTextType="I18N"
                                valueText={idTransaction.substring(0, 8).toUpperCase()}
                                valueTextType="TEXT"
                            />
                        </GridTable.Data>
                    </GridTable.Container>
                </GridTable>
            )}

                <GridTable className="box e-checks-summary px-0 pb-0">
                    <GridTable.Container columns={3} rows={3} columnsTemplate={columnTemplate}>
                        {(echeqAction.action !== "ANULATE-CESION" && (
                            <>
                                <GridTable.Data {...getCellProps(1, 1, 3)}>
                                    <CustomData
                                        titleText="echecks.cesion.beneficiaryCuit"
                                        titleTextType="I18N"
                                        valueText={beneficiary.substring(5)}
                                        valueTextType="TEXT"
                                    />
                                </GridTable.Data>

                                <GridTable.Data {...getCellProps(1, 2, 3)}>
                                    <CustomData
                                        titleText="echecks.beneficiary"
                                        titleTextType="I18N"
                                        valueText={beneficiaryName}
                                        valueTextType="TEXT"
                                    />
                                </GridTable.Data>

                                <GridTable.Data {...getCellProps(1, 3, 3)}>
                                    <CustomData
                                        titleText="echecks.echeckReference"
                                        titleTextType="I18N"
                                        valueText={reference}
                                        valueTextType="TEXT"
                                    />
                                </GridTable.Data>
                            </>
                        ))}

                        <GridTable.Data {...(echeqAction.action !== "ANULATE-CESION" ? getCellProps(2, 1, 3) : getCellProps(2, 1, 3))}>
                            <CustomData
                                titleText="echecks.currency"
                                titleTextType="I18N"
                                valueText={getCurrency()} />
                        </GridTable.Data>

                        <GridTable.Data {...(echeqAction.action !== "ANULATE-CESION" ? getCellProps(2, 2, 3) : getCellProps(2, 2, 3))}>
                            <CustomData
                                titleText="echecks.amount"
                                titleTextType="I18N"
                                valueText={<FormattedAmount currency={getCurrency()} quantity={getAmoutTotal()} />}
                                valueTextType="TEXT"
                            />
                        </GridTable.Data>

                        {echeqAction.action !== "ANULATE-CESION" && (
                            <GridTable.Data {...getCellProps(2, 3, 3)}>
                                <CustomData
                                    titleText="echecks.echeckReferenceValue"
                                    titleTextType="I18N"
                                    valueText={referencevalue}
                                    valueTextType="TEXT"
                                />
                            </GridTable.Data>
                        )}

                        <GridTable.Data {...(echeqAction.action !== "ANULATE-CESION" ? getCellProps(3, 1, 3) : getCellProps(1, 1, 3))}>
                            <CustomData
                                titleText="echecks.quantity.echeqs"
                                titleTextType="I18N"
                                valueText={echeqList.length}
                                valueTextType="TEXT"
                            />
                        </GridTable.Data>

                        <GridTable.Data {...(echeqAction.action !== "ANULATE-CESION" ? getCellProps(3, 2, 3) : getCellProps(1, 2, 3))}>
                            <CustomData
                                titleText="echecks.echeckNature"
                                titleTextType="I18N"
                                valueText={caracter}
                                valueTextType="TEXT"
                            />
                        </GridTable.Data>

                        {echeqAction.action === "ANULATE-CESION" && (
                            <GridTable.Data {...getCellProps(2, 3, 3)}>
                                <CustomData
                                    titleText="echecks.motive.label"
                                    titleTextType="I18N"
                                    valueText={echeqAction.specialAttribute}
                                    valueTextType="TEXT"
                                />
                            </GridTable.Data>
                        )}

                    </GridTable.Container>
                </GridTable>

            {idTransaction && (
                <GridTable className="box e-checks-summary px-0">
                    <GridTable.Container columns={1} rows={1} columnsTemplate={columnTemplate}>
                        <GridTable.Data {...getCellProps(1, 1)}>
                            <CustomData
                                titleText="transaction.process.details.heading.totalAmount"
                                titleTextType="I18N"
                                valueText={
                                    <FormattedAmount className="data-label" currency={currency} quantity={quantity} />
                                }
                                valueTextType="TEXT"
                            />
                        </GridTable.Data>
                        <GridTable.Data {...getCellProps(1, 2)}>
                            <CustomData
                                titleText="echecks.response"
                                titleTextType="I18N"
                                valueText={coelsaResponse}
                                valueTextType="TEXT"
                            />
                        </GridTable.Data>
                        <GridTable.Data {...getCellProps(1, 3)}>
                            <CustomData
                                titleText="echecks.codeMessage"
                                titleTextType="I18N"
                                valueText={coelsaCode}
                                valueTextType="TEXT"
                            />
                        </GridTable.Data>
                    </GridTable.Container>
                </GridTable>
            )}
        </>
    );
};

CesionSummaryMultipleBody.propTypes = {
    beneficiary: shape({
        reference: string,
        document: string,
    }),
    echeqList: arrayOf(echeqPropTypes),
    address: string,
    referencevalue: string,
    reference: string,
    isDesktop: bool.isRequired,
};

CesionSummaryMultipleBody.defaultProps = {
    beneficiary: {
        reference: "",
        document: "",
    },
    echeqList: [],
    address: "",
    referencevalue: "",
    reference: "-",
};

export default CesionSummaryMultipleBody;
